import { useEffect, useState } from "react";
import { navBarData } from "./NavBarData";
import "./NavBar.css";
import { NavLink, Link } from "react-router-dom";

interface NavProps {
  hideNav?: boolean;
}

function NavBar({ hideNav }: NavProps) {
  const [activeLink, setActiveLink] = useState<number>(0);

  const getUrl = (linkName: string) => {
    return linkName.toLowerCase();
  };

  useEffect(() => {
    const currentPath = window.location.pathname;

    const index = navBarData.findIndex(
      (link) => `/${getUrl(link.name)}` === currentPath
    );

    if (index !== -1) {
      setActiveLink(index);
    }
  }, []);

  return (
    <div className="nav-wrapper">
      <div className="nav-content">
        <div className="binLogo-div">
          <Link to="/" className="daqtanklogo">
            DAQtank
          </Link>
        </div>
        <div className="low-nav-content">
          <div className="nav-links">
            {navBarData.map((link, index) => (
              <NavLink
                to={index === 0 ? "/" : `/${getUrl(link.name)}`}
                key={index}
                className={
                  index === activeLink ? "nav-link activeLink" : "nav-link"
                }
                onClick={() => setActiveLink(index)}
              >
                <img
                  src={
                    index === activeLink ? link.activeLink : link.inactiveLink
                  }
                  alt="link"
                />
              </NavLink>
            ))}
          </div>
          {/* <NavLink to="/" className="logout">
            <img src="./images/nav/logout.svg" alt="logout" />
          </NavLink> */}
        </div>
      </div>
      <div
        className="mobile-nav"
        style={{ display: hideNav ? "flex" : "none" }}
      >
        <div className="low-nav-content">
          <div className="nav-links">
            {navBarData.map((link, index) => (
              <NavLink
                to={index === 0 ? "/" : `/${getUrl(link.name)}`}
                key={index}
                className={
                  index === activeLink ? "nav-link activeLink" : "nav-link"
                }
                onClick={() => setActiveLink(index)}
              >
                <img
                  src={
                    index === activeLink ? link.activeLink : link.inactiveLink
                  }
                  alt="link"
                />
                <p className="nav-link-name">{link.name}</p>
              </NavLink>
            ))}
          </div>
          {/* <NavLink to="/" className="logout">
            <img src="./images/nav/logout.svg" alt="logout" />
            <p className="nav-link-name">Logout</p>
          </NavLink> */}
        </div>
      </div>
    </div>
  );
}

export default NavBar;
